import React, { useEffect } from 'react';
import Wrapper from '../../../wrapper/Wrapper';
import Button from '../../common/CommonButton/Button';

const OrderSummary = (props) => {

    // Use Effect is a react hook which incorporate all lifecycle hooks of Class based
    // components
    useEffect(() => {
        console.log('Order Summary Is rendering....');
    });

    const li = Object.keys(props.ingredients).map(key => {
    return <li key={key}>
        <span style={{textTransform:'capitalize'}}>{key}</span>:{props.ingredients[key]}
        </li>
    })
    return (
        <Wrapper>
            <h3 style={{textAlign:'center'}}>Your Order Summary!</h3>
            <ul >
                {li}
            </ul>
            <p style={{textAlign:'center'}}><strong>Total Price : {props.totalPrice.toFixed(2)}</strong></p>
            <p style={{textAlign:'center'}}>Continue to Checkout ?</p>
            <div style={{display:'flex',justifyContent:'center'}}>
                <Button type="Danger" clicked={props.openSummary}>CANCEL</Button>
                <Button type="Success" clicked={props.order}>CONTINUE</Button>
            </div>
        </Wrapper>
    );
}

export default OrderSummary;